import * as React from "react";
import { useInstantSearch } from "react-instantsearch";
import { MediaQuery, Button } from "@grandvisionhq/common";
import { Container, Heading } from "@grandvisionhq/elements";
import hasProductTypeFacet from "../../Algolia/utils/Algolia/utils/has-Product-type-facet.js";
import { FacetId } from "../../types.js";
import { parseFacets } from "../utils/SearchPageHeader/utils/parse-facets.js";
/* empty css                      */
import { useAlgoliaConfig } from "../../Algolia/Algolia/AlgoliaConfig.js";
import { SearchPageDescription } from "../components/SearchPageDescription/SearchPageHeader/components/SearchPageDescription/SearchPageDescription.js";
import { FacetsMobile } from "../../Algolia/components/FacetsMobile/Algolia/components/FacetsMobile/FacetsMobile.js";
import { SortBy } from "../../Algolia/components/SortBy/Algolia/components/SortBy/SortBy.js";
import FacetsDesktop from "../../Algolia/components/FacetsDesktop/Algolia/components/FacetsDesktop/FacetsDesktop.js";
const ProductPageSelectorGroup = ({
  productPageSelector = []
}) => /* @__PURE__ */ React.createElement("div", { className: "search-page-header__product-page-selectors" }, productPageSelector.map((element, index) => {
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      key: `${element.name}-${index}}`,
      className: "search-page-header__product-page-selectors-button",
      "data-t": element.name,
      href: element.url,
      hrefTarget: "_self",
      caption: element.label,
      variant: "solid",
      color: "primary",
      size: "small"
    }
  );
}));
const SearchPageHeader = ({
  pageTitle,
  hitTitle,
  description,
  facetOrder,
  productPageSelector
}) => {
  const { facets, sortIndices } = useAlgoliaConfig();
  const { indexUiState } = useInstantSearch();
  const isMobile = MediaQuery.useBreakpoint() === MediaQuery.BreakpointName.PHONE;
  const hasProductType = hasProductTypeFacet(indexUiState, facets);
  const productTypeFacet = facets.find((facet) => facet.id === FacetId.productType);
  const productTypeFacetValue = productTypeFacet && indexUiState.refinementList ? indexUiState.refinementList[productTypeFacet.attribute]?.[0]?.toUpperCase() : void 0;
  const facetsVisible = parseFacets({ facets, hasProductType, facetOrder, productTypeFacetValue });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "search-page-header" }, /* @__PURE__ */ React.createElement(Container, { className: "search-page-header__container" }, /* @__PURE__ */ React.createElement("div", { className: "search-page-header__intro" }, pageTitle && /* @__PURE__ */ React.createElement(Heading, { variant: "medium", component: "h1", className: "search-page-header__title" }, pageTitle), description && /* @__PURE__ */ React.createElement(SearchPageDescription, { description })), isMobile && productPageSelector?.length ? /* @__PURE__ */ React.createElement(ProductPageSelectorGroup, { productPageSelector }) : null, isMobile && /* @__PURE__ */ React.createElement(FacetsMobile, { facets: facetsVisible }), (hitTitle || sortIndices) && /* @__PURE__ */ React.createElement("div", { className: "search-page-header__sort-results" }, hitTitle && /* @__PURE__ */ React.createElement("div", { className: "search-page-header__amount-hits", "data-t": "plp-amount-hits" }, hitTitle), sortIndices.length > 0 ? /* @__PURE__ */ React.createElement("div", { className: "search-page-header__sort-by" }, /* @__PURE__ */ React.createElement(SortBy, { items: sortIndices })) : null), !isMobile && productPageSelector?.length ? /* @__PURE__ */ React.createElement(ProductPageSelectorGroup, { productPageSelector }) : null), !isMobile && /* @__PURE__ */ React.createElement(FacetsDesktop, { facets: facetsVisible })));
};
export {
  SearchPageHeader,
  SearchPageHeader as default
};
//# sourceMappingURL=SearchPageHeader.js.map
